<template>
    
    <div class="container">
        <div class="row col-md-9 mx-auto my-5">
            <h2 class="mt-5" style="font-weight: bold;">آکادمی ناباکو پلی به سوی دانش و موفقیت</h2>
            <div class="row mt-5 mx-auto">
                <div class="col-md-9">
                    <h5 class="mt-3">
                        آکادمی ناباکوبه‌گونه‌ای طراحی شده است که به شما ابزارها و دانش مورد نیاز برای درک عمیق‌تر دنیای مالی و فناوری‌های پیشرفته را ارائه دهد. این بخش از سایت، یک مرکز آموزشی جامع است که منابع، دوره‌ها، و مقالاتی با کیفیت بالا در سه حوزه کلیدی سواد مالی، بلاکچین و هوش مصنوعی ارائه  می نماید.
                    </h5>
                    <h5 class="mt-4">اهداف آکادمی ناباکو</h5>
                    <h5 class="mt-3">
                        <strong>افزایش دانش عمومی:</strong>ما معتقدیم که دانش قدرت است. هدف آکادمی ناباکو آموزش مفاهیم پیچیده به زبان ساده و قابل‌فهم است.
                        <br>
                        <br>
                        <strong>توانمندسازی تریدرها و سرمایه‌گذاران:</strong>با ارائه اطلاعات عملی و کاربردی، به شما کمک می‌کنیم تصمیمات آگاهانه‌تری بگیرید.
                        <br>
                        <br>
                        <strong>اتصال دانش به عمل:</strong>یادگیری مفاهیم به‌تنهایی کافی نیست؛ ما به شما کمک می‌کنیم که از آموخته‌ها در زندگی واقعی و معاملات مالی خود استفاده کنید
                    </h5>

                </div>
                <div class="col-md-3">
                    <img src="../../assets/logo.png" class="d-md-block d-none" style="width: 215px;" alt="">
                    <img src="../../assets/logo.png" class="d-md-none d-block mx-auto" style="width: 100px;" alt="">
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-12 row">
                    <div class="col-md-6">
                        <img src="../../../public/img/HosseinMalekinezhad.png" width="100%" alt="">
                    </div>
                    <div class="col-md-6 my-auto text-end">
                        <h3>دکتر حسین مالکی نژاد</h3>
                        <h5>رئیس هیئت مدیره</h5>
                        <h5>سابقه فعالیت مدیر تکنولوژی فناوری های بانکی</h5>
                        <h5>دکترای هوش مصنوعی و یادگیری ماشین</h5>
                        <h5>راه اندازی سیستم های های پیش بینی در صنعت مالی </h5>
                    </div>
                </div>
                <div class="col-12 row">
                    <div class="col-md-6 my-auto text-end">
                        <h3>حسین موذن</h3>
                        <h5>مدیرعامل</h5>
                        <h5>کارشناسی ارشد مدیریت – استراتژ</h5>
                        <h5>سابقه فعالیت راه اندازی سیستم های هوشمند در صنعت نفت و گاز و پتروشیمی</h5>
                        <h5>مشاوره  و راه اندازی  سیستم های مبتنی بر هوش مصنوعی و اینترنت اشیا</h5>
                        <h5>راه اندازی کسب و کارهای نوپا در ایران و شمال امریکا </h5>
                    </div>
                    <div class="col-md-6">
                        <img src="../../../public/img/HoseinMoazen.png" width="100%" alt="">
                    </div>
                </div>
                <!-- <div class="col-12 row">
                    <div class="col-md-6">
                        <img src="../../../public/img/miladTarverdi.png" width="100%" alt="">
                    </div>
                    <div class="col-md-6 my-auto text-end">
                        <h3>دکتر میلاد تاروردی</h3>
                        <h5>هم بنیانگذار و CMO</h5>
                        <h5>دکترای مدیریت کسب وکار - گرایش تحول دیجیتال</h5>
                        <h5>مدرس دوره های آموزشی MBA و دوره های کسب و کار در دانشگاه شهید بهشتی</h5>
                        <h5>مدرس دوره های آموزشی MBA (مهارتی و کاربردی) در دانشگاه آزاد</h5>
                        <h5>مشاور و مجری پروژه های دیجیتالیزه برای بیش از 20 کسب و کار</h5>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>